import React from "react";

import Heading from "../Heading/Heading";

import Homepageblue from "../../img/homepage_blue.png";
import Logo from "../../img/archie_logo_white.png";

import "./SideContext.scss";

export function SideContext() {
  return (
    <div className="side-context">
      <img
        className="side-context__logo"
        height={50}
        src={Logo}
        alt="Cloudbuddies"
      />
      <Heading level={2} modifiers={["major", "yellow"]}>
        Cloudbuddies
        <br /> Cloud Self-Service Portal
      </Heading>
      <p>
        Build infrastructures in minutes without Coding or Architecting skills.
        Predefined, Customisable, secured and well architected as a standard.
      </p>

      <div className="side-context__diagram">
        <img src={Homepageblue} alt="Archie Process Diagram" />
      </div>
      {/* <Heading level={1} modifiers={["major", "yellow"]}>
      The new home for Cloud Deployments <br />
      </Heading> */}

      <p>
        Delivering Cloud Landing zones, Accounts, Resources, Infrastructures
        Stacks has never been easier, faster, compliant and secure
      </p>
    </div>
  );
}

export default SideContext;
